import React, { useState, useEffect } from 'react'
import { Menu } from 'antd';
import { CloseCircleFilled, CaretUpOutlined, CaretDownOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom'
import axios from 'axios';
import './FilterMenu.css'

const materials = [
    {
        label: '正牌料',
        key: '/market/firstclass',
    }, {
        label: '副牌料',
        key: '/market/secondclass',
    }, {
        label: '再生料',
        key: '/market/recycled',
    }
];

export default function FilterMenu() {
    const params = useParams();
    const [mainCategories, setMainCategories] = useState([])
    const [subCategories, setSubCategories] = useState([])
    const [subIndex, setSubIndex] = useState(0)

    const [chooseCat, setChooseCat] = useState('')
    const [chooseSubCat, setChooseSubCat] = useState('')

    const [selectedKeys, setSelectedKeys] = useState([]);
    const [selectedSubKeys, setSelectedSubKeys] = useState([]);

    const [isOrdeByPrice, setOrderByPrice] = useState(false)
    const [isOrdeByTime, setOrderByTime] = useState(false)

    const [orderBy, setOrderBy] = useState('default')
    const [orderByType, setOrderByType] = useState('')

    const navigate = useNavigate()

    useEffect(() => {
        let source = axios.CancelToken.source();

        async function fetchData() {
            try {
                let res;
                const cachedData = localStorage.getItem("categories");
                // 如果有缓存数据，直接使用
                if (cachedData) {
                    res = JSON.parse(cachedData);                
                } else {
                    // 从远程获取数据
                    res = await axios.get("https://api.360ep.cn/api/category/?type=sep", {
                        cancelToken: source.token,
                    });

                    // 将获取到的数据存储到localStorage中
                    localStorage.setItem("categories", JSON.stringify(res.data));
                    res = res.data;
                }

                let menuItems = [];
                let subMenuItems = [];
                let index = 0;
                
                res.data.forEach(item => {
                    let subMenu = [];

                    menuItems.push({
                        label: item.catname,
                        key: index
                    });
                                        
                    if (params.appid && params.appid.toString() === item.catid.toString()) {                                           
                        setChooseCat(item.catname)
                        setSelectedKeys([index.toString()])
                    }

                    item.children.forEach(subItem => {
                        subMenu.push({
                            label: subItem.catname,
                            key: "/market/" + subItem.catid,
                        });
                        if (params.appid && params.appid.toString() === subItem.catid.toString()) {
                            setChooseSubCat(subItem.catname)
                            setChooseCat(item.catname)
                            setSelectedKeys([index.toString()])
                            setSelectedSubKeys(["/market/" + subItem.catid])
                        }
                    });
                    index += 1;

                    subMenuItems.push(subMenu);
                });

                setMainCategories(menuItems);
                setSubCategories(subMenuItems);                
            } catch (error) {
                if (axios.isCancel(error)) {
                    console.log("Request canceled", error.message);
                } else {
                    console.log("Error", error.message);
                }
            }
        }

        fetchData();

        return () => {
            source.cancel("Request canceled by user");
        };
    }, [params.appid]);


    function chooseMenu(event) {
        setChooseSubCat(event.domEvent.currentTarget.innerText)
        //console.log(selectedSubKeys)
        //console.log(event.key)
        setSelectedSubKeys([event.key])
        navigate(event.key)
    }

    function chooseCategory(event) {
        //console.log(event.key) 
        setChooseCat(event.domEvent.currentTarget.innerText)
        setSelectedKeys([event.key])
        setSubIndex(event.key)
    }

    function clearCat() {
        setChooseCat('')
        setSelectedKeys([])
        setChooseSubCat('')
        setSelectedSubKeys([])
        setOrderBy("default")
        navigate("/market")
    }

    function changeOrderByPrice() {
        setOrderBy("price")
        let catid = "/market/0"
        if (selectedSubKeys.length > 0) {
            catid = selectedSubKeys[0]
        }

        setOrderByPrice(!isOrdeByPrice)

        if (isOrdeByPrice) {
            setOrderByType("desc")
            navigate(catid + "/price/desc")
        } else {
            setOrderByType("asc")
            navigate(catid + "/price/asc")
        }
        console.log(orderByType)
    }

    function changeOrderByTime() {
        setOrderBy("time")
        let catid = "/market/0"
        if (selectedSubKeys.length > 0) {
            catid = selectedSubKeys[0]
        }
        setOrderByTime(!isOrdeByTime)

        if (isOrdeByTime) {
            setOrderByType("desc")
            navigate(catid + "/addtime/desc")
        } else {
            setOrderByType("asc")
            navigate(catid + "/addtime/asc")
        }
    }

    function changeOrderByDefault() {
        setOrderBy("default")
        let catid = "/market/0"
        if (selectedSubKeys.length > 0) {
            catid = selectedSubKeys[0]
        }
        navigate(catid)
    }

    return (
        <div>
            <div className="filter-menu">
                <div className="menu-section">
                    <span className="menu-title">应用分类：</span>
                    <Menu mode="horizontal"
                        theme="light"
                        className="side-menu"
                        triggerSubMenuAction="hover"
                        items={mainCategories}
                        selectedKeys={selectedKeys}
                        onClick={chooseCategory}
                    />
                </div>

                <div className="menu-section">
                    <span className="menu-title">应用细分：</span>
                    <Menu mode="horizontal"
                        theme="light"
                        className="side-menu"
                        triggerSubMenuAction="hover"
                        items={subCategories[subIndex]}
                        selectedKeys={selectedSubKeys}
                        onClick={chooseMenu}
                    />
                </div>

                <div className="menu-section">
                    <span className="menu-title">材料类型：</span>
                    <Menu mode="horizontal"
                        theme="light"
                        className="side-menu"
                        triggerSubMenuAction="hover"
                        items={materials}
                    //onClick={chooseMenu}
                    />
                </div>
            </div>

            <div className="choose-section">
                <div className="menu-choose">
                    <span className="choose-title">应用于：</span>
                    {chooseCat && (<span className="choose-cat" onClick={clearCat}>{chooseCat}<CloseCircleFilled style={{ color: 'red', marginLeft: "5px" }} /></span>)}
                    {chooseSubCat && (
                        <span className="choose-cat" onClick={clearCat}>{chooseSubCat}<CloseCircleFilled style={{ color: 'red', marginLeft: "5px" }} /></span>
                    )}
                </div>
                <div className="menu-choose">
                    <span className="choose-title">特种材料：</span>
                    <span className="choose-rank" style={orderBy === 'default' ? { color: 'red' } : {}} onClick={changeOrderByDefault}>综合排序</span>
                    <span className="choose-rank" style={orderBy === 'price' ? { color: 'red' } : {}} onClick={changeOrderByPrice}>价格{orderBy === 'price' && isOrdeByPrice && (<CaretUpOutlined />)}{orderBy === 'price' && !isOrdeByPrice && (<CaretDownOutlined />)}</span>
                    <span className="choose-rank" style={orderBy === 'time' ? { color: 'red' } : {}} onClick={changeOrderByTime}>发布时间{orderBy === 'time' && isOrdeByTime && (<CaretUpOutlined />)}{orderBy === 'time' && !isOrdeByTime && (<CaretDownOutlined />)}</span>
                </div>
            </div>
        </div>
    )
}
